import { hc } from "hono/client"
import type { app } from "../../api/index.ts"

const url = (() => {
  if (
    import.meta.env.DEV &&
    import.meta.env.VITE_TUNNEL_API_URL &&
    globalThis.location?.hostname.includes("tunnel")
  )
    return import.meta.env.VITE_TUNNEL_API_URL
  return `${globalThis.origin}/api`
})()

export const rpc = hc<app>(url, {
  init: {
    credentials: "include",
  },
})
